
import { defineComponent } from 'vue';
import {CustomModels} from "@/BabylonExamples/CustomModels"



export default defineComponent({
  name: 'BabylonExamples',
  mounted(){
    const canvas = document.querySelector("canvas")!;
    new CustomModels(canvas);
  },
  data() {
    return { morality: 120, purity: 80 };
  },
  methods: {
    incrementMorality() {
      this.morality++;
    },
    decrementMorality() {
      this.morality--;
    },
    incrementPurity() {
      this.purity++;
    },
    decrementPurity() {
      this.purity--;
    },
  },
  
});
